import { useEffect } from 'react';

import { Loader } from 'src/components/ui/Loader';
import { useAppNavigate } from 'src/hooks/useAppNavigate';
import { useCurrentUser } from 'src/hooks/useCurrentUser';

export function HomePage() {
  const { isAuthenticated } = useCurrentUser();
  const { toLoginPage, toClinicsPage, toClinicPage } = useAppNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      toLoginPage();
    } else {
      toClinicPage();
    }
  }, [toClinicPage, toLoginPage, toClinicsPage, isAuthenticated]);

  return <Loader isLoading />;
}
